import { type Alert, AlertStatus, AlertType } from '@alltrails/types/Alert';

const isClosureOrDangerAlertActive = (alert: Alert) => {
  return (alert.alertType === AlertType.CLOSURE || alert.alertType === AlertType.DANGER) && alert.status === AlertStatus.ACTIVE;
};

export default isClosureOrDangerAlertActive;
